import { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import submitPartDeliveryRequest from '../services/PartDeliveryService';
import './PartDeliveryPage.scss';

const capacityMessage = 'We are currently at capacity in your area today. Drop your mobile number and email to get notified the exact minute a runner frees up. We sincerely apologise for any inconvenience and thank you for your understanding.';

export default function PartDeliveryPage() {
    const [showCapacityDialog, setShowCapacityDialog] = useState(true);
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [orderDetails, setOrderDetails] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState({ type: '', text: '' });

    const handleDialogOk = () => {
        setShowCapacityDialog(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!name.trim() || !phoneNumber.trim()) {
            setStatus({ type: 'error', text: 'Please enter both your name and phone number.' });
            return;
        }

        setIsSubmitting(true);
        setStatus({ type: '', text: '' });

        try {
            await submitPartDeliveryRequest({
                name: name.trim(),
                phoneNumber: phoneNumber.trim(),
                orderDetails: orderDetails.trim()
            });

            setStatus({ type: 'success', text: 'Request submitted. We will contact you when a runner is free.' });
            setName('');
            setPhoneNumber('');
            setOrderDetails('');
            if (window.fbq) {
                window.fbq('track', 'Lead', { value: 1 });
            }
        } catch (error) {
            setStatus({ type: 'error', text: 'Unable to submit your request right now. Please try again.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="part-delivery-page">
            <Dialog open={showCapacityDialog} aria-labelledby="capacity-dialog-title" maxWidth="sm" fullWidth>
                <DialogTitle id="capacity-dialog-title">Notice</DialogTitle>
                <DialogContent>
                    <Typography>{capacityMessage}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={handleDialogOk}>OK</Button>
                </DialogActions>
            </Dialog>

            {!showCapacityDialog && (
                <form className="part-delivery-card" onSubmit={handleSubmit}>
                    <h1 className="part-delivery-title">Part Delivery Request</h1>
                    <p className="part-delivery-hint">Enter your details and submit to request parts delivery.</p>

                    <div className="part-delivery-field">
                        <label htmlFor="part-delivery-name">Name</label>
                        <input
                            id="part-delivery-name"
                            type="text"
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            placeholder="Your full name"
                        />
                    </div>

                    <div className="part-delivery-field">
                        <label htmlFor="part-delivery-phone">Phone number</label>
                        <input
                            id="part-delivery-phone"
                            type="tel"
                            value={phoneNumber}
                            onChange={(event) => setPhoneNumber(event.target.value)}
                            placeholder="04xx xxx xxx"
                        />
                    </div>

                    <div className="part-delivery-field">
                        <label htmlFor="part-delivery-order-details">Your order details (optional)</label>
                        <textarea
                            id="part-delivery-order-details"
                            value={orderDetails}
                            onChange={(event) => setOrderDetails(event.target.value)}
                            placeholder="Describe the parts you need (if easy to describe)"
                            rows={4}
                        />
                    </div>

                    <button className="part-delivery-submit" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>

                    {status.text && (
                        <p className={`part-delivery-message ${status.type}`}>
                            {status.text}
                        </p>
                    )}
                </form>
            )}
        </div>
    );
}
